module.exports = __webpack_public_path__ + "ui-static/img/cluster-wizard-fallback_light.5010ffb4.svg";